import { makeRequestService } from '@vatsim-petersburg/utils';
import { CORE_BASE_URL } from '@/constants/constants';

export const coreRequestService = makeRequestService(CORE_BASE_URL);
